import script from "./App.vue?vue&type=script&setup=true&lang=ts"
export * from "./App.vue?vue&type=script&setup=true&lang=ts"

import "./App.vue?vue&type=style&index=0&id=36607c18&scoped=true&lang=less"

import exportComponent from "D:\\code\\GPT\\front-web\\chat-gpt-laset\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36607c18"]])

export default __exports__